export function objectIsEmpty(data: Record<string, any>): boolean {
  return Object.values(data).every((v) => v === '' || v === null || v === undefined);
}

export function cloneObject(data: Record<string, any>): any {
  return JSON.parse(JSON.stringify(data));
}
